import {t} from "./i18n/index.js";

// Plain, GeoJSON-compatible data model for a digitized feature.
// Deliberately independent of THREE.js/Potree - the visual representation
// (FeatureVisual) is a separate object kept in sync by DigitizationModule.

let counter = 0;

export function createFeature(options = {}){
	counter++;

	const now = new Date().toISOString();

	return {
		id: `feature_${Date.now().toString(36)}_${counter}`,
		type: "Feature",
		geometry: {
			type: options.geometryType,
			coordinates: options.coordinates,
		},
		properties: {
			name: options.name || `Feature ${counter}`,
			category: options.category || t("Uncategorized"),
			tool: options.tool || null,
			featureType: options.featureType || null,
			description: options.description || "",
			user: options.user || null,
			attributes: options.attributes || {},
		},
		// Semantic domain-layer data, keyed by domain namespace (e.g. "danva") -
		// deliberately a SIBLING of `properties`, not a few more keys inside
		// `properties`/`properties.attributes` (DANVA task section 6: "Undgå
		// en implementation hvor DANVA-properties spredes direkte ud på
		// almindelige feature-properties"). `properties` stays exactly what
		// every existing tool already knows: this feature's own generic
		// PointView-level data (name/category/tool/attributes bag), regardless
		// of whether some external domain has also classified it as one of
		// its object types. Empty by default so every existing feature/tool
		// is completely unaffected - a plain LineString has `domainData: {}`
		// forever, unless something explicitly adds a namespace to it (see
		// danva/DanvaDomainData.js's classify()).
		domainData: options.domainData || {},
		// Stabilt id for den punktsky/model, registreringen tilhoerer - IKKE
		// modelnavnet, og IKKE arrayplaceringen af den aktive punktsky. Her i
		// createFeature() er det blot en valgfri passthrough (default null) -
		// de ~15 eksisterende tool-callsites kender ikke til den og sender den
		// derfor ikke, saa den rigtige vaerdi stemples paa EFTER oprettelse, i
		// DigitizationModule.registerNewFeature()/_wireFeatureLifecycle() (den
		// faelles chokepoint alle vaerktoejer allerede gaar igennem), fra den
		// punktsky der var aktiv (setActivePointcloud()) da registreringen blev
		// oprettet. Forbliver null for registreringer oprettet foer denne
		// relation fandtes, eller hvis ingen model var aktiv paa
		// oprettelsestidspunktet - se FolderManager/UNFILED for haandtering.
		pointcloudId: options.pointcloudId != null ? options.pointcloudId : null,
		metadata: {
			created: now,
			modified: now,
		},
	};
}

export function touchFeature(feature){
	feature.metadata.modified = new Date().toISOString();
}
